import React from "react";
import { motion } from "framer-motion";
import CustomNavbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

export default function HairConcerns() {

  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.8 } }
  };

  const slideUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const hairProblems = [
    {
      title: "Hair Loss",
      text: "Hair loss may occur due to genetics, hormonal imbalance, stress or nutritional deficiency. Early treatment helps prevent further hair thinning."
    },
    {
      title: "Dandruff & Scalp Infection",
      text: "Dandruff and scalp infections can cause itching, irritation and hair fall. Medical scalp treatments help control these issues."
    },
    {
      title: "Hair Thinning",
      text: "Hair thinning makes the hair look weak and reduces hair density. Advanced therapies help strengthen hair roots."
    },
    {
      title: "Alopecia",
      text: "Alopecia causes sudden patchy hair loss on the scalp. Dermatological treatments help stimulate natural hair regrowth."
    }
  ];

  const treatments = [
    "PRP Hair Treatment",
    "Hair Growth Therapy",
    "Hair Fall Treatment",
    "Scalp Treatment"
  ];

  return (
    <>
      <CustomNavbar />

      <div className="container py-5">

        <motion.h1
          className="text-center mb-4"
          style={{ color: "#9b2226" }}
          variants={fadeIn}
          initial="hidden"
          animate="visible"
        >
          Hair Concerns & Hair Loss Treatments
        </motion.h1>

        <p className="text-center mb-5">
          Hair loss and scalp problems can affect both men and women.
          Our clinic provides advanced hair treatments to improve hair
          health, control hair fall and stimulate natural hair growth.
        </p>

        <h2 className="text-center mb-4">Common Hair Problems We Treat</h2>

        <div className="row g-4">

          {hairProblems.map((item, index) => (
            <div className="col-md-6 col-lg-3" key={index}>
              <motion.div
                className="card h-100 shadow-sm border-0"
                variants={slideUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                whileHover={{
                  scale: 1.06,
                  boxShadow: "0px 15px 30px rgba(0,0,0,0.15)"
                }}
              >
                <div className="card-body text-center">
                  <h3 style={{ color: "#9b2226" }}>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </motion.div>
            </div>
          ))}

        </div>

        <h2 className="text-center mt-5 mb-4">
          Advanced Hair Treatments Available
        </h2>

        <div className="row g-4">

          {treatments.map((treatment, index) => (
            <div className="col-md-3" key={index}>
              <motion.div
                className="card text-center shadow-sm border-0"
                variants={slideUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 10px 25px rgba(0,0,0,0.15)"
                }}
              >
                <div className="card-body">
                  <h4 style={{ color: "#9b2226" }}>{treatment}</h4>
                </div>
              </motion.div>
            </div>
          ))}

        </div>

      </div>

      <Footer />
    </>
  );
}